// src/admin/components/FormField.tsx
import type { ReactNode } from 'react';
import styles from './FormField.module.css';

// `error` / `hint` accept `undefined` explicitly (not just "may be absent")
// because callers commonly pass `errors.foo?.message` from react-hook-form
// which is typed `string | undefined`. Under exactOptionalPropertyTypes the
// two are not interchangeable.
export default function FormField({
  label, htmlFor, error, hint, required, children,
}: {
  label: string;
  htmlFor?: string | undefined;
  error?: string | undefined;
  hint?: string | undefined;
  required?: boolean | undefined;
  children: ReactNode;
}) {
  return (
    <div className={styles.field}>
      <label htmlFor={htmlFor}>{label}{required && <span className={styles.req}> *</span>}</label>
      {children}
      {error ? <span className={styles.err}>{error}</span> : hint ? <span className={styles.hint}>{hint}</span> : null}
    </div>
  );
}
